import { createContext, useContext } from 'react';

import { useHirerAccountAndUserDataQuery } from 'src/graphql/generated';

/**
 * WARNING: Do not insert values in here and access it directly
 * This is meant for fragments to get their cache ID
 * Please speak to the team if you find yourself needing to add to this context
 */
interface HirerInfoContext {
  seekAdvertiserId?: string;
  userId?: string | null;
}

interface HirerInfoProviderProps {
  children: React.ReactNode;
}

const HirerInfoContext = createContext<HirerInfoContext>({});

export const useHirerInfoContext = () => useContext(HirerInfoContext);
export const HirerInfoProvider = ({ children }: HirerInfoProviderProps) => {
  const { data } = useHirerAccountAndUserDataQuery({
    variables: {
      advertiserNation: 'deprecated',
    },
    fetchPolicy: 'cache-only',
  });

  const { hirerAccount, identity } = data || {};

  return (
    <HirerInfoContext.Provider
      value={{
        seekAdvertiserId: hirerAccount?.id,
        userId: identity?.subject.userId,
      }}
    >
      {children}
    </HirerInfoContext.Provider>
  );
};
